import { render } from "./PosCustomerComponent.vue?vue&type=template&id=5d1da491"
import script from "./PosCustomerComponent.vue?vue&type=script&lang=js"
export * from "./PosCustomerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pos/PosCustomerComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d1da491"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d1da491', __exports__)) {
    api.reload('5d1da491', __exports__)
  }
  
  module.hot.accept("./PosCustomerComponent.vue?vue&type=template&id=5d1da491", () => {
    api.rerender('5d1da491', render)
  })

}


export default __exports__